import { createSlice } from 'utils/@reduxjs/toolkit';
import { RootStoreState } from './types';
import { useInjectReducer } from 'utils/redux-injectors';
import { StorageServices } from 'utils/storage';
import { MAX_TOASTS, SELECT_THEME } from 'common/config/constant';
import toast from 'react-hot-toast';

export const initialState: RootStoreState = {
  theme: 'light',
  pinned: true,
  toastQueue: [],
  headerHolder: '',
};

const slice = createSlice({
  name: 'root',
  initialState,
  reducers: {
    changeTheme: (state, { payload }) => {
      state.theme = payload;
      const isDarkMode = payload === 'dark';
      StorageServices.setData(SELECT_THEME, payload);

      if (isDarkMode) {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
      } else {
        document.documentElement.classList.add('light');
        document.documentElement.classList.remove('dark');
      }
    },
    changePinned: (state, { payload }) => {
      state.pinned = payload;
    },
    changeHeader: (state, { payload }) => {
      state.headerHolder = payload;
    },
    addToast: (state, { payload }) => {
      const updatedQueue = [...state.toastQueue, payload];
      if (updatedQueue.length > MAX_TOASTS) {
        const [oldestToast, ...restQueue] = updatedQueue;
        toast.dismiss(oldestToast.id);
        state.toastQueue = restQueue;
      } else {
        state.toastQueue = updatedQueue;
      }
    },
  },
});

export const { actions } = slice;

export const useRootSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });

  return {
    actions: slice.actions,
  };
};
